import { Component, OnInit } from "@angular/core";
@Component({
  selector: "gh-example-divider-component",
  templateUrl: "./example-divider.component.html",
  styleUrls: ["./example-divider.component.less"],
})
export class ExampleDividerComponent implements OnInit {
  ngOnInit(): void {
    // Empty this is not!
  }
}
